<template>
  <!-- 创建群组 -->
  <div
    aria-labelledby="myModalLabel"
    class="modal fade"
    id="newgroup"
    role="dialog"
    aria-hidden="true"
    data-backdrop="static"
    tabindex="-1"
  >
    <div class="modal-dialog" id="newgroup-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button
            aria-label="Close"
            class="close"
            data-dismiss="modal"
            type="button"
          >
            <span aria-hidden="true">×</span>
          </button>
          <h4 class="modal-title" id="myModalLabel">创建群组</h4>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <input
              class="form-control"
              placeholder="群组名称"
              type="text"
              v-model.trim="form.group_name"
              name="group_name"
              data-vv-as="群组名称 "
              v-validate="{ required: true, max: 50 }"
            />
            <span class="help-block" v-show="errors.has('group_name')">{{
              errors.first("group_name")
            }}</span>
          </div>
          <div class="form-group">
            <textarea
              class="form-control"
              placeholder="群组简介"
              style="resize: vertical"
              rows="4"
              v-model.trim="form.group_description"
              name="group_description"
              data-vv-as="群组简介 "
              v-validate="{ max: 255 }"
            ></textarea>
            <span class="help-block" v-show="errors.has('group_description')">{{
              errors.first("group_description")
            }}</span>
          </div>
          <div class="form-group">
            <select
              class="form-control selectpicker"
              v-model="form.group_category_number"
              name="group_category_number"
              data-vv-as="群组分类 "
              v-validate="{ required: true }"
            >
              <option
                v-for="cate in categorys"
                :key="cate.group_category_number"
                :value="cate.group_category_number"
              >
                {{ cate.group_category_name }}
              </option>
            </select>
            <span
              class="help-block"
              v-show="errors.has('group_category_number')"
              >{{ errors.first("group_category_number") }}</span
            >
          </div>
          <!-- <div class="form-group">
            <div class="share-user">
              <div class="list" v-for="(tag,index) in form.tags_list" :key="index">
                <i class="ti-tag"></i>
                <p>{{tag}}</p>
                <i class="ti-close close" @click="removeTag(index)"></i>
              </div>
              <input
                class="share-input"
                placeholder="群组标签，按Enter添加"
                type="text"
                v-model.trim="tag"
                @keyup.enter="addTag"
                name="tag"
                data-vv-as="群组标签 "
                v-validate="{ max: 10 }"
              />
            </div>
            <span class="help-block" v-show="errors.has('tag')">{{ errors.first('tag') }}</span>
          </div>-->
          <div class="form-group">
            <div class="upload-groupavator">
              <div class="preview" id="view">
                <img
                  v-if="cropImg"
                  :src="cropImg"
                  style="width: 60px; height: 60px"
                />
                <input
                  id="filebtn"
                  :value="uploadValue"
                  type="file"
                  accept="image/jpg, image/jpeg, image/gif, image/png"
                  name="image"
                  @change="setImage"
                />
              </div>
              <button
                v-show="cropImg"
                type="button"
                class="btn btn-danger btn1"
                @click="cancleCropImage"
              >
                移除
              </button>
              <p :style="pStyle" v-show="!cropImg">点击这里上传logo</p>
              <p :style="pStyle">logo裁剪大小为400*400像素</p>
            </div>
            <span class="help-block" v-show="errors.has('file')">{{
              errors.first("file")
            }}</span>
          </div>
          <!-- <div class="form-group">
            <div class="checkbox i-checks">
              <label>
                <input type="checkbox" v-model="form.is_public" />
                <i></i>
                群组公开可见
              </label>
            </div>
          </div>-->
          <div class="form-group">
            <div class="checkbox i-checks">
              <label>
                <input type="checkbox" v-model="form.is_auto_audit_mem_add" />
                <i></i>
                成员申请入群自动审核通过
              </label>
            </div>
          </div>
          <div class="form-group">
            <div class="checkbox i-checks">
              <label>
                <input
                  name="is_agree_protocol"
                  type="checkbox"
                  v-model="form.is_agree_protocol"
                  @change="changeAgreeProtocol"
                />
                <i></i>
                同意
                <router-link
                  target="_blank"
                  :to="{ name: 'content' }"
                  style="color: #006adf"
                  >《群使用协议》</router-link
                >
              </label>
            </div>
            <span class="help-block" v-show="errors.has('is_agree_protocol')">{{
              errors.first("is_agree_protocol")
            }}</span>
          </div>
        </div>
        <div class="modal-footer">
          <button
            class="btn btn-default"
            data-dismiss="modal"
            type="button"
            v-show="!loading"
          >
            取消
          </button>
          <button
            class="btn btn-primary"
            :class="{ loading: loading }"
            type="button"
            @click="createGroup"
          >
            {{ createText }}
          </button>
        </div>
      </div>
      <div class="crop-image" v-if="imgSrc && showCropper">
        <vue-cropper
          ref="cropper3"
          :guides="true"
          :view-mode="2"
          drag-mode="crop"
          :aspect-ratio="1"
          :auto-crop-area="0.9"
          :min-container-width="500"
          :min-container-height="400"
          :background="true"
          :rotatable="true"
          :src="imgSrc"
          alt="群Logo"
          :cropmove="cropMove"
          :img-style="{ width: '500px', height: '400px' }"
        ></vue-cropper>
      </div>
    </div>
  </div>
</template>

<script>
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
import debounce from "lodash.debounce";
import { publicFileUpload } from "@/api/common/index";
import { getGroupCategorys, checkGroupName, group } from "@/api/group/group";
export default {
  name: "GroupCreate",
  components: { VueCropper },
  data() {
    return {
      uploadValue: "",
      loading: false,
      showDownCrop: true,
      showCropper: false,
      cropImg: "",
      imgSrc: "",
      tag: "",
      categorys: [],
      form: {
        group_number: "",
        group_category_number: "1",
        group_name: "",
        group_description: "",
        group_logo: null,
        // group_banner: "",
        is_public: true, // 暂时屏蔽了，先默认公开
        is_auto_audit_mem_add: false,
        is_agree_protocol: false,
        // tags_list: []
      },
    };
  },
  created() {
    this.debouncedCheckGroupName = debounce(this.checkGroupName, 500);
  },
  watch: {
    "form.group_name": {
      handler: function (newValue) {
        if (newValue) {
          this.debouncedCheckGroupName();
        }
      },
    },
  },
  computed: {
    createText() {
      return this.loading ? "正在创建..." : "创建";
    },
    pStyle() {
      return this.cropImg
        ? "padding-left: 10px;line-height: 60px;"
        : "padding-left: 100px;line-height: 30px;";
    },
  },
  methods: {
    checkGroupName() {
      checkGroupName({
        group_number: 0,
        search_name: this.form.group_name,
      })
        .then((res) => {
          if (res.status_code === 423) {
            this.errors.add({
              field: "group_name",
              msg: res.message,
            });
          } else {
            this.errors.remove("group_name");
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    cancleCropImage() {
      this.form.group_logo = null;
      this.imgSrc = "";
      this.showCropper = false;
      window.URL.revokeObjectURL(this.cropImg);
      this.cropImg = "";
      // this.$refs.cropper3.reset(); //没有效果，Q：当选择一个图片后，取消后，再上传一个相同的图，就无法上传了
    },
    setImage(e) {
      this.uploadValue = "";
      const file = e.target.files[0];
      if (!file) {
        return;
      }
      this.showDownCrop = true;
      this.cropImg = window.URL.createObjectURL(file);
      if (!file.type.includes("image/")) {
        this.$message({
          type: "warning",
          message: "请选择一个图片类型文件",
        });
        return;
      }
      if (typeof FileReader === "function") {
        const reader = new FileReader();
        reader.onload = (event) => {
          this.showCropper = true;
          this.imgSrc = event.target.result;
          this.$nextTick(() => {
            this.$refs.cropper3.replace(event.target.result);
          });
        };
        reader.readAsDataURL(file);
      } else {
        alert("Sorry, FileReader API not supported");
      }
    },
    cropImage(group_res) {
      if (!this.imgSrc) {
        this.$message({
          type: "success",
          message: group_res.message,
        });
        $("#newgroup").modal("hide");
        this.form.group_name = "";
        this.form.group_description = "";
        this.loading = false;
        this.$emit("groupCreated");
        return false;
      }
      this.$refs.cropper3
        .getCroppedCanvas({
          width: 400,
          height: 400,
          imageSmoothingEnabled: false,
          imageSmoothingQuality: "high",
        })
        .toBlob((blob) => {
          const formData = new FormData();
          formData.append("file", blob);
          formData.append("type", 2);
          formData.append("group_number", group_res.entity.group_number);
          publicFileUpload(formData)
            .then((res) => {
              if (res.status_code === 200) {
                $("#newgroup").modal("hide");
                this.loading = false;
                this.$emit("groupCreated");
                this.cancleCropImage();
                this.showCropper = false;
                this.showDownCrop = false;
                this.$message({
                  type: "success",
                  message: res.message,
                });
                this.form.group_name = "";
                this.form.group_description = "";
              } else {
                $("#newgroup").modal("hide");
                this.loading = false;
                this.$emit("groupCreated");
                this.cancleCropImage();
                this.$message({
                  type: "error",
                  message: "群组创建成功，" + res.message,
                });
                this.form.group_name = "";
                this.form.group_description = "";
              }
            })
            .catch((err) => {
              $("#newgroup").modal("hide");
              this.loading = false;
              this.$emit("groupCreated");
              this.cancleCropImage();
              this.$message({
                type: "error",
                message: "群组创建成功，" + err,
              });
              this.form.group_name = "";
              this.form.group_description = "";
            });
        });
    },
    cropMove() {
      this.cropImg = this.$refs.cropper3
        .getCroppedCanvas({
          width: 400,
          height: 400,
          imageSmoothingEnabled: false,
          imageSmoothingQuality: "high",
        })
        .toDataURL();
    },
    // addTag() {
    //   this.$validator.validate("tag").then(valid => {
    //     if (valid) {
    //       let exist = this.form.tags_list.find(
    //         item => item === this.tag
    //       );
    //       if (!exist) {
    //         this.form.tags_list.push(this.tag);
    //       }

    //       this.tag = "";
    //     }
    //   });
    // },
    // removeTag(index) {
    //   this.form.tags_list.splice(index, 1);
    // },
    getGroupCategorys() {
      getGroupCategorys()
        .then((res) => {
          if (res.status_code === 200) {
            this.categorys = res.entity;
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    changeAgreeProtocol() {
      if (this.form.is_agree_protocol) {
        this.errors.remove("is_agree_protocol");
      } else {
        this.errors.add({
          field: "is_agree_protocol",
          msg: "请选择同意群使用协议",
        });
      }
    },
    createGroup() {
      if (this.errors.has("group_name")) {
        return false;
      }
      this.tag = "";
      this.$validator.validate().then((valid) => {
        if (valid) {
          if (!this.form.is_agree_protocol) {
            this.errors.add({
              field: "is_agree_protocol",
              msg: "请选择同意群使用协议",
            });
            return false;
          }
          if (!this.imgSrc) {
            this.errors.add({
              field: "file",
              msg: "请上传群Logo",
            });
            return false;
          }

          this.loading = true;
          group(this.form)
            .then((res) => {
              if (res.status_code === 200) {
                this.$nextTick(() => {
                  this.$validator.reset();
                });
                // this.form.group_logo = res.entity.file_url;
                // 上传群图片
                this.cropImage(res);
              } else {
                this.loading = false;
                this.$message({
                  type: "error",
                  message: res.message,
                });
              }
            })
            .catch((err) => {
              this.loading = false;
              this.$message({
                type: "error",
                message: err,
              });
            });
        }
      });
    },
  },
  mounted() {
    $("#newgroup").on("show.bs.modal", () => {
      this.getGroupCategorys();
    });
  },
  destroyed() {
    $("#newgroup").off();
  },
};
</script>

<style scoped>
.loading {
  pointer-events: none;
}
#newgroup-dialog {
  position: relative;
}
.crop-image {
  /* z-index: 9999; */
  position: absolute;
  top: 0px;
  left: -500px;
  width: 500px;
  height: 300px;
}
.upload-groupavator .btn1 {
  margin-left: 90px;
  display: inline-block;
}
.upload-groupavator .btn2 {
  margin-left: 10px;
  display: inline-block;
}
.disabled {
  pointer-events: none;
}
</style>